"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = void 0;
exports.isArray = Array.isArray;
//# sourceMappingURL=array.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/lib/util/array.js
// module id = i3IR
// module chunks = 1